<section class="auto-height disabled-login-fields">
  <article>
    <div class="form-wrapper mob-view">
      <form class="" role="form" name="sign-in">

        <!-- Start: Trick to escape mac safari autofill bug -->
        <div class="sr-only">
          <label aria-hidden="true" for="email" id="labelEmail" class="top-set">{{'wifiLogin.login.label' | translate}}</label>
          <input id="email" name="UserName" type="text" disabled required/>
        </div>
        <div class="sr-only">
          <label aria-hidden="true" for="password" class="top-set">{{'wifiLogin.password.label' | translate}}</label>
          <input id="password" name="Password" type="password" disabled required />
        </div>
        <!-- End: Trick to escape mac safari autofill bug -->

        <div class="input-set large-6 medium-6 small-12 col" tabindex="0">
          <label aria-hidden="true" for="email" id="labelEmail" class="top-set">{{'wifiLogin.login.label' | translate}}</label>
          <input [(ngModel)]="loggedInUsername" id="email" name="UserName" type="text" disabled required autocomplete="off" />
          <div class="tool-tip bottom-left small error onboard-tool-tip onboard-tool-tip-mob" role="alert">
            <div class="tool-tip-inner">
              <div>{{'message.'+alreadyLoginError | translate}}</div>
            </div>
          </div>
        </div>

        <div class="input-set large-6 medium-6 small-12 bdr-l-none col last" tabindex="0">
          <label aria-hidden="true" for="password" class="top-set">{{'wifiLogin.password.label' | translate}}</label>
          <input [(ngModel)]="samplePassword" id="password" name="Password" type="password" disabled required autocomplete="off" />
        </div>

        <fieldset class="wifi-checkboxs clear pad-t-20">
          <legend class="hideElement"></legend>
          <div class="checkbox-wrap">
            <input type="checkbox" id="sainandan" disabled>
            <label for="sainandan" class="text-white">
              <span class=" icon-ok" tabindex="0"></span>
              {{'wifiLogin.label.sasTnC' | translate}}
              <a href="javascript:void(0)" (click)="openSasTnC()">{{'wifiLogin.sasTnC' | translate}}</a>
            </label>
          </div>
        </fieldset>

        <div class="wrap-button small-12  margin-auto center pad-l-8 pad-r-8">
          <button class="btn primary medium large-4 medium-4 small-12 center mrgn-t-30 disabled" id="login" role="button" aria-labelledby="Click here to login"
            title="Login">{{'wifiLogin.connect' | translate}}</button>
        </div>
      </form>
    </div>
  </article>
</section>
